(() => {
  'use strict';

  const initFeaturedCollection = (root) => {
    if (!root || root.dataset.gentsInitialized === 'true') return;
    root.dataset.gentsInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    const activateTab = (tab) => {
      const targetId = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const active = panel.id === targetId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();

        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        const nextTab = tabs[nextIndex];
        activateTab(nextTab);
        nextTab.focus();
        nextTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    // Quick add is optional. Tab switching must initialize regardless of
    // whether Quick Add is enabled in the Theme Editor.
    if (!root.matches('[data-quick-add="true"]')) return;

    const forms = root.querySelectorAll('[data-product-form]');

    forms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-quick-add-button]');
        if (!button || button.disabled) return;

        const label = button.querySelector('.gents-product-card__quick-add-label');
        const originalLabel = label ? label.textContent : 'Add to cart';

        button.disabled = true;
        button.classList.add('is-loading');
        if (label) label.textContent = 'Adding…';

        try {
          const formData = new FormData(form);

          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });

          if (!response.ok) {
            throw new Error('Unable to add product to cart.');
          }

          const item = await response.json();

          button.classList.remove('is-loading');
          button.classList.add('is-success');
          if (label) label.textContent = 'Added';

          document.dispatchEvent(
            new CustomEvent('gents:cart:item-added', {
              bubbles: true,
              detail: { item }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:open', {
              bubbles: true
            })
          );

          window.setTimeout(() => {
            button.classList.remove('is-success');
            button.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 1800);
        } catch (error) {
          console.error('[GENTS Featured Collection]', error);

          button.classList.remove('is-loading');
          button.disabled = false;
          if (label) label.textContent = 'Try again';

          window.setTimeout(() => {
            if (label) label.textContent = originalLabel;
          }, 1800);
        }
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('.gents-featured-collection').forEach(initFeaturedCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.gents-featured-collection');
    if (root) initFeaturedCollection(root);
  });
})();
